import React from 'react';
import { Box, Typography, Avatar, Grid } from '@mui/material';
import Card from './UIKit/Card';
import { useTranslation } from 'react-i18next';

/**
 * Компонент для предпросмотра значка в различных размерах
 */
const BadgePreview = ({ imageSrc, badgeTitle, rarity, tier }) => {
  const { t } = useTranslation(['badges', 'common']);

  // Функция для получения цвета в зависимости от редкости значка
  const getRarityColor = (rarity) => {
    switch (rarity) {
      case 'common':
        return '#989898';
      case 'uncommon':
        return '#58ac30';
      case 'rare':
        return '#3d85c6';
      case 'epic':
        return '#9b59b6';
      case 'legendary':
        return '#e67e22';
      default:
        return '#989898';
    }
  };

  // Расчет стилей для бордюров значков разных уровней
  const getTierStyle = (tier) => {
    const base = {
      borderWidth: 2,
      borderStyle: 'solid',
      borderColor: getRarityColor(rarity),
    };

    switch (tier) {
      case 'bronze':
        return base;
      case 'silver':
        return {
          ...base,
          boxShadow: '0 0 5px rgba(192, 192, 192, 0.7)',
        };
      case 'gold':
        return {
          ...base,
          boxShadow: '0 0 8px rgba(255, 215, 0, 0.7)',
        };
      case 'platinum':
        return {
          ...base,
          boxShadow: '0 0 10px rgba(229, 228, 226, 0.9)',
          borderWidth: 3,
        };
      default:
        return base;
    }
  };

  return (
    <Card>
      <Typography variant="h6" gutterBottom>
        {t('badges:badgePreview.title')}
      </Typography>

      <Grid container spacing={3} justifyContent="center" alignItems="center">
        <Grid item>
          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="body2" gutterBottom>
              {t('badges:badgePreview.sizes.small')}
            </Typography>
            <Avatar
              src={imageSrc}
              alt={badgeTitle}
              sx={{
                width: 24,
                height: 24,
                margin: '0 auto',
                ...getTierStyle(tier),
              }}
            />
          </Box>
        </Grid>
        <Grid item>
          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="body2" gutterBottom>
              {t('badges:badgePreview.sizes.medium')}
            </Typography>
            <Avatar
              src={imageSrc}
              alt={badgeTitle}
              sx={{
                width: 48,
                height: 48,
                margin: '0 auto',
                ...getTierStyle(tier),
              }}
            />
          </Box>
        </Grid>
        <Grid item>
          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="body2" gutterBottom>
              {t('badges:badgePreview.sizes.large')}
            </Typography>
            <Avatar
              src={imageSrc}
              alt={badgeTitle}
              sx={{
                width: 96,
                height: 96,
                margin: '0 auto',
                ...getTierStyle(tier),
              }}
            />
          </Box>
        </Grid>
      </Grid>

      <Box sx={{ mt: 2, textAlign: 'center' }}>
        <Typography variant="body2" color="text.secondary">
          {t('badges:badgePreview.recommendation')}
        </Typography>
      </Box>
    </Card>
  );
};

export default BadgePreview;
